import { render } from "./DatasetSpecification.vue?vue&type=template&id=173ace58"
import script from "./DatasetSpecification.vue?vue&type=script&lang=js"
export * from "./DatasetSpecification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__